import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <main className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <span
        className="absolute bottom-0 text-9xl md:text-[12rem] font-heading font-black text-background-200/40 select-none pointer-events-none z-0"
        aria-hidden="true"
      >
        404
      </span>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950 mt-6">
          This page has not been generated
        </h1>
        <p className="mt-2 text-base text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-foreground-500">
          Tell me more about this page, so I can generate it
        </p>
      </div>
    </main>
  );
}